module.exports = __webpack_public_path__ + "static/logo-211201-676764bf321c3e97323ff50c1278e91f.svg";